const Domains  = [
  {
    domain: ['www.luxuracart.com'],
    code: 'IN'
  },
];

export default Domains;